import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AwardSection from "../AwardSection/Awards";
import GwrSection from "../GwrSection/GwrSection";

const WorldRecords = () => {
  const location = useLocation();

  useEffect(() => {
    const sectionId = location.pathname.substring(1); // Remove leading "/"

    setTimeout(() => {
      const sectionElement = document.getElementById(sectionId);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100); // Small delay to ensure elements are rendered
  }, [location]);

  return (
    <div id="world-records" className="category-page">
      <AwardSection id="awards-and-recognition" />
      <GwrSection id="guinness-world-records" />
    </div>
  );
};

export default WorldRecords;
